import { render, staticRenderFns } from "./SendCreditsSpecialists.vue?vue&type=template&id=55028e96&scoped=true&"
import script from "./SendCreditsSpecialists.vue?vue&type=script&lang=js&"
export * from "./SendCreditsSpecialists.vue?vue&type=script&lang=js&"
import style0 from "./SendCreditsSpecialists.vue?vue&type=style&index=0&id=55028e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55028e96",
  null
  
)

export default component.exports